
import { images } from "../constants";

const destinations = [
    {
        id: 1,
        image: images.des1,
        title: "Yosemite Valley",
        details: {
            location: "California, USA",
            terrainType: "Granite Cliffs, Waterfalls, Meadows, Forests",
            elevationRange: "1,200 m to 4,000 m",
            idealDuration: "5 - 10 Days",
            languageSpoken: "English",
            currency: "USD",
            budget: "$200 - $1000",
            bestSeason: "Spring and Fall",
        },
        overviews: [
            "Discover the beauty and adventure awaiting you at Yosemite Valley. Nestled in the heart of the Sierra Nevada, Yosemite is renowned for its breathtaking scenery, towering granite cliffs, majestic waterfalls, and diverse wildlife. It offers an unparalleled experience for nature lovers and adventure seekers alike."
        ],
        climate: [
            "Sunny Summers and Mild Winters",
            "Occasional Showers in Spring",
            "Snowfall in Higher Elevations During Winter",
            "Prepare for Rainy Days with Proper Gear",
            "Enjoy Pleasant Autumns with Colorful Foliage"
        ],
        landscape: [
            "Rocky Mountains and Lush Valleys",
            "Dense Forests with Hiking Trails",
            "Crystal-clear Lakes and Flowing Rivers",
            "Campsites Nestled Amongst Nature",
            "Explore Scenic Views and Hidden Gems"
        ],
        facilities: [
            "Spacious Campgrounds with Fire Pits",
            "Well-marked Trails for Hiking and Trekking",
            "Clean Restrooms and Shower Facilities",
            "Firewood and Picnic Areas for Outdoor Dining",
            "Wildlife Viewing and Birdwatching Opportunities"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.340689441532!2d-119.574233!3d37.7455701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8096f1eeecae5a01%3A0x94f98d0eb5e6f59!2sYosemite%20Valley%2C%20CA%2095379%2C%20USA!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des1Gallery1,
            images.des1Gallery2,
            images.des1Gallery3,
            images.des1Gallery4,
            images.des1Gallery5,
            images.des1Gallery6,
        ],
        accommodationsIds: [1, 2, 3, 6],
        activitiesIds: [1, 2, 3, 4],
    },
    {
        id: 2,
        image: images.des2,
        title: "Rocky Mountain",
        details: {
            location: "Colorado, USA",
            terrainType: "Mountains, Alpine Tundra, Forests",
            elevationRange: "2,300 m to 4,350 m",
            idealDuration: "5 - 10 Days",
            languageSpoken: "English",
            currency: "USD",
            budget: "$200 - $1000",
            bestSeason: "Spring and Fall",
        },
        overviews: [
            "Explore the majestic beauty of the Rocky Mountains, known for its towering peaks, alpine lakes, and diverse wildlife. A paradise for outdoor enthusiasts, it offers thrilling adventures like hiking, wildlife spotting, and scenic drives."
        ],
        climate: [
            "Cool Summers and Cold Winters",
            "Heavy Snowfall in Winter",
            "Rainy Spring with Pleasant Autumn",
            "Occasional Thunderstorms in Summer",
            "Fresh Mountain Air Year-round"
        ],
        landscape: [
            "Tall Snow-Capped Peaks",
            "Alpine Lakes and Valleys",
            "Extensive Hiking Trails",
            "Lush Forests and Meadows",
            "Wildlife-filled National Parks"
        ],
        facilities: [
            "Spacious Campgrounds with Fire Pits",
            "Comfortable Lodges with Scenic Views",
            "Well-maintained Trails for Hiking",
            "Heated Cabins for Cold Nights",
            "Outdoor Dining Areas and Picnic Tables"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3086.661706144226!2d-105.6836386!3d40.3427938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876961af214250d3%3A0x38c0b3f1e0535e60!2sRocky%20Mountain%20National%20Park!5e0!3m2!1sen!2sus!4v1715803654321!5m2!1sen!2sus",
        gallery: [
            images.des2Gallery1,
            images.des2Gallery2,
            images.des2Gallery3,
            images.des2Gallery4,
            images.des2Gallery5,
            images.des2Gallery6,
        ],
        accommodationsIds: [1, 2, 5, 6],
        activitiesIds: [1, 2, 5, 6],
    },
    {
        id: 3,
        image: images.des3,
        title: "Banff National Park",
        details: {
            location: "Alberta, Canada",
            terrainType: "Rocky Mountains, Glacial Lakes, Forests",
            elevationRange: "1,400 m to 3,600 m",
            idealDuration: "5 - 10 Days",
            languageSpoken: "English",
            currency: "CAD",
            budget: "$300 - $1200",
            bestSeason: "Summer and Fall",
        },
        overviews: [
            "Banff National Park, nestled in the heart of the Canadian Rockies, is a spectacular destination known for its crystal-clear lakes, towering mountains, and abundant wildlife. Whether you’re looking to hike, bike, or simply relax, Banff offers breathtaking views and unforgettable experiences."
        ],
        climate: [
            "Warm Summers and Cold Winters",
            "Heavy Snowfall in Winter",
            "Mild Spring with Cool Nights",
            "Beautiful Autumn Foliage",
            "Ideal Weather for Outdoor Activities Year-round"
        ],
        landscape: [
            "Crystal-clear Glacial Lakes",
            "Majestic Snow-covered Peaks",
            "Vast Pine Forests and Meadows",
            "Wildlife-rich National Park",
            "Alpine Hikes with Panoramic Views"
        ],
        facilities: [
            "Luxurious Resorts with Mountain Views",
            "Lodges and Cabins with Cozy Fireplaces",
            "Public Parks for Picnicking and Relaxing",
            "Numerous Trails for Hiking and Biking",
            "Heated Pools and Wellness Centers"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d102397.82925626156!2d-115.6764607!3d51.4968466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5378d4a54b5b3d91%3A0xa67d2f624eb18232!2sBanff%20National%20Park!5e0!3m2!1sen!2sca!4v1715804200000!5m2!1sen!2sca",
        gallery: [
            images.des3Gallery1,
            images.des3Gallery2,
            images.des3Gallery3,
            images.des3Gallery4,
            images.des3Gallery5,
            images.des3Gallery6,
        ],
        accommodationsIds: [2, 3, 5, 6],
        activitiesIds: [1, 2, 4, 5, 6],
    },
    {
        id: 4,
        image: images.des4,
        title: "Torres del Paine",
        details: {
            location: "Patagonia, Southern Chile",
            terrainType: "Mountains, Glaciers, Rivers, Lakes",
            elevationRange: "50 m to 3,050 m",
            idealDuration: "6 - 12 Days",
            languageSpoken: "Spanish",
            currency: "CLP",
            budget: "$500 - $1500",
            bestSeason: "Spring and Summer",
        },
        overviews: [
            "Torres del Paine National Park in southern Chile is a breathtaking destination known for its rugged beauty, dramatic mountains, glaciers, and turquoise lakes. A haven for outdoor enthusiasts, this park offers exceptional hiking and a chance to experience the wilds of Patagonia."
        ],
        climate: [
            "Windy with Sudden Weather Changes",
            "Mild Summers with Daytime Sunshine",
            "Cold and Snowy Winters",
            "Rainy Days are Frequent in the Spring",
            "Spring and Summer are Ideal for Hiking"
        ],
        landscape: [
            "Towering Granite Peaks and Glaciers",
            "Crystal-clear Blue Lakes",
            "Wide, Windswept Plains",
            "Lush Patagonian Forests",
            "Dramatic Waterfalls and Rivers"
        ],
        facilities: [
            "Tented Camps for Adventure Seekers",
            "Eco-lodges for Comfort and Sustainability",
            "Mountain Refugios for Hikers",
            "Guided Tours and Trekking",
            "Well-marked Trails for All Skill Levels"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d802692.723936144!2d-73.3805186!3d-50.9423016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xbc4d93e332f1e7a7%3A0x46272f8986cb8f2b!2sTorres%20del%20Paine%20National%20Park!5e0!3m2!1sen!2scl!4v1715804720000!5m2!1sen!2scl",
        gallery: [
            images.des4Gallery1,
            images.des4Gallery2,
            images.des4Gallery3,
            images.des4Gallery4,
            images.des4Gallery5,
            images.des4Gallery6,
        ],
        accommodationsIds: [1, 3, 4, 5],
        activitiesIds: [1, 2, 4, 5],
    },
    {
        id: 5,
        image: images.des5,
        title: "Mount Kilimanjaro",
        details: {
            location: "Northeastern Tanzania, near Moshi",
            terrainType: "Volcanic Mountain, Forests, Alpine Desert",
            elevationRange: "1,800 m to 5,895 m",
            idealDuration: "7 - 14 Days",
            languageSpoken: "Swahili, English",
            currency: "TZS",
            budget: "$1000 - $3000",
            bestSeason: "June to October",
        },
        overviews: [
            "Mount Kilimanjaro is Africa's highest peak and a world-renowned destination for climbers. This majestic mountain offers a diverse range of ecosystems, from tropical rainforest to alpine desert, making it a truly unique challenge for adventurers aiming to reach the summit."
        ],
        climate: [
            "Tropical at the Base, Cold at the Summit",
            "Rainy Season from March to May",
            "Sunny and Warm Weather in the Dry Season",
            "Cold and Windy at Higher Elevations",
            "Clear Skies and Pleasant Weather in the Dry Season"
        ],
        landscape: [
            "Mountaintop Views Over Tanzania and Kenya",
            "Tropical Rainforests at the Base",
            "Alpine Meadows and Deserts Near the Summit",
            "Snow-capped Peak of Kilimanjaro",
            "Breathtaking Sunrises and Sunsets"
        ],
        facilities: [
            "Tented Camps Along the Route",
            "Mountain Huts at Higher Elevations",
            "Porters and Guides to Assist Climbers",
            "Fresh Water and Food Supplies Along the Trail",
            "Well-maintained Trails with Stunning Views"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d315011.9092746883!2d37.3535434!3d-3.0758336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19d7a209f02171df%3A0x7a4c8d5d5ad7be56!2sMount%20Kilimanjaro!5e0!3m2!1sen!2s!4v1715805234567!5m2!1sen!2s",
        gallery: [
            images.des5Gallery1,
            images.des5Gallery2,
            images.des5Gallery3,
            images.des5Gallery4,
            images.des5Gallery5,
            images.des5Gallery6,
        ],
        accommodationsIds: [1, 3, 5],
        activitiesIds: [1, 2, 5],
    },
    {
        id: 6,
        image: images.des6,
        title: "Zion National Park",
        details: {
            location: "Southwestern Utah, United States",
            terrainType: "Canyons, Cliffs, River Valleys",
            elevationRange: "1,117 m to 2,660 m",
            idealDuration: "3 - 7 Days",
            languageSpoken: "English",
            currency: "USD",
            budget: "$150 - $800",
            bestSeason: "Spring and Fall",
        },
        overviews: [
            "Zion National Park, located in the heart of southern Utah, is a paradise for outdoor enthusiasts. With its iconic red rock cliffs, narrow canyons, and diverse wildlife, Zion offers breathtaking landscapes and thrilling hiking trails for all adventure seekers."
        ],
        climate: [
            "Hot and Dry Summers",
            "Mild Winters with Occasional Snow",
            "Ideal Hiking Conditions in Spring and Fall",
            "Thunderstorms Possible in Summer Months",
            "Cooler Temperatures at Higher Elevations"
        ],
        landscape: [
            "Majestic Red Rock Cliffs and Canyons",
            "The Famous Angels Landing Trail",
            "The Narrows: A River Hike Through a Canyon",
            "Wildflower Blooms in Spring",
            "Stunning Sunrises and Sunsets"
        ],
        facilities: [
            "Campgrounds with Modern Amenities",
            "Lodging Options Near the Park Entrance",
            "Ranger-led Educational Programs",
            "Shuttle Service to Popular Trails",
            "Visitor Center with Maps and Information"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d506888.3297748932!2d-113.0572867!3d37.1782916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874c46a1e72f5e57%3A0x911c79d88e26fc64!2sZion%20National%20Park!5e0!3m2!1sen!2sus!4v1715805700000!5m2!1sen!2sus",
        gallery: [
            images.des6Gallery1,
            images.des6Gallery2,
            images.des6Gallery3,
            images.des6Gallery4,
            images.des6Gallery5,
            images.des6Gallery6,
        ],
        accommodationsIds: [1, 2, 3, 6],
        activitiesIds: [1, 2, 3, 4],
    }
];

export default destinations;